import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardBody, Col, Input, Label, Row, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledTooltip, Container, Button } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { MoreVertical, Trash, Eye, Check, X } from 'react-feather';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash.debounce';
import { getAllOrganizations as getAllOrganizationsAction, toggleOrganizationStatus as toggleOrganizationStatusAction, addMatchCredits as addMatchCreditsAction, addContactCredit as addContactCreditAction, deleteOrganizations as deleteOrganizationsAction, updateOrganizationSeats as updateOrganizationSeatsAction, subscribeOrganizationPittiPlan as subscribeOrganizationPittiPlanAction, subscribeHyperscoutPlan as subscribeHyperscoutPlanAction, subscribeCustomHyperscoutPlan as subscribeCustomHyperscoutPlanAction, toggleSubscription as toggleSubscriptionAction, activateTrial as activateTrialAction, cancelSubscription as cancelSubscriptionAction, toggleOrganizationBrandSetupFlow as toggleOrganizationBrandSetupFlowAction, resetOrganizationAccount as resetOrganizationAccountAction, getOrganizationFilters as getOrganizationFiltersAction, setFilters as setFiltersAction, getOrganizationMetrics as getOrganizationMetricsAction, exportOrganizations as exportOrganizationsAction, removeOrganizationReferral as removeOrganizationReferralAction, sendInviteEmail as sendInviteEmailAction } from '../ReduxToolkit/Reducers/organizationManagement';
import { markHubspotTriggered as markHubspotTriggeredAction } from '../ReduxToolkit/Reducers/brandRequests'
import EditSeatsModal from './EditSeatsModal';
import SubscribePittiPlanModal from './SubscribePittiPlanModal';
import SubscribeHyperscoutPlanModal from './SubscribeHyperscoutPlanModal';
import PlanDetailsModal from './PlanDetailsModal';
import OrganizationDetailsModal from './OrganizationDetailsModal';
import ConfirmationModal from './ConfirmationModal';
import ActivateTrialModal from './ActivateTrialModal';
import CancelSubscriptionModal from './CancelSubscriptionModal';
import { getCamelCaseWord } from '../static/brands_wholesalers_data';
import MultiSelectFilterDropDown from '../CommonElements/MultiSelectFilterDropDown';
import axios from 'axios';
import { toast } from 'react-toastify';
import AddMatchCreditsModal from './AddMatchCreditsModal';

function OrganizationManagementTab({ getAllOrganizations, allOrganizations, totalOrganizations, markHubspotTriggered, isLoading, toggleOrganizationStatus, addMatchCredits, addContactCredit, updateOrganizationSeats, subscribeOrganizationPittiPlan, subscribeHyperscoutPlan, subscribeCustomHyperscoutPlan, toggleSubscription, deleteOrganizations, activateTrial, cancelSubscription, toggleOrganizationBrandSetupFlow, resetOrganizationAccount, getOrganizationFilters, setFilters, filterData, filterLoading, filters, getOrganizationMetrics, exportOrganizations, removeOrganizationReferral, sendInviteEmail }) {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchText, setSearchText] = useState('');
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tableData, setTableData] = useState([]);
  const [creditModalOpen, setCreditModalOpen] = useState(false);
  const [seatsModalOpen, setSeatsModalOpen] = useState(false);
  const [planModalOpen, setPlanModalOpen] = useState(false);
  const [hyperscoutPlanModalOpen, setHyperscoutPlanModalOpen] = useState(false);
  const [planDetailsModalOpen, setPlanDetailsModalOpen] = useState(false);
  const [organizationDetailsModalOpen, setOrganizationDetailsModalOpen] = useState(false);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [selectedRowsData, setSelectedRowsData] = useState(null);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [singleDeleteOrg, setSingleDeleteOrg] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [trialModalOpen, setTrialModalOpen] = useState(false);
  const [cancelSubConfirmModal, setCancelSubConfirmModal] = useState(false);
  const [cancelSubOrg, setCancelSubOrg] = useState(null);
  const [cancelSubOrgName, setCancelSubOrgName] = useState(null);
  const [cancelSubLoading, setCancelSubLoading] = useState(false);
  const [resetAccountModal, setResetAccountModal] = useState(false);
  const [singleResetAccountOrg, setSingleResetAccountOrg] = useState(null);
  const [resetAccountLoading, setResetAccountLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [inviteLoadingOrgId, setInviteLoadingOrgId] = useState(null);

  const handleSendInvite = async (org) => {
    try {
      setInviteLoadingOrgId(org.id);
      await sendInviteEmail(org.id);
    } finally {
      setInviteLoadingOrgId(null);
    }
  };

  const handleExport = async () => {
    try {
      setExportLoading(true);
      await exportOrganizations(searchText, filters);
    } finally {
      setExportLoading(false);
    }
  };

  useEffect(() => {
    getOrganizationFilters();
  }, []);

  useEffect(() => {
    if (page) {
      _getTableData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, searchText, itemsPerPage, filters]);

  useEffect(() => {
    if (allOrganizations[page]) {
      setTableData(allOrganizations[page]);
    }
  }, [allOrganizations, page]);

  const _getTableData = async (hideLoader = false) => {
    await getAllOrganizations(page, searchText, itemsPerPage, filters, hideLoader);
  };

  const _searchOrganizations = (inputValue) => {
    const query = inputValue?.trim();
    setPage(1);
    setSearchText(query);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceFn = useCallback(debounce(_searchOrganizations, 1000), []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    debounceFn(e.target.value);
  };

  const handleItemPerPageSelect = async (count) => {
    setPage(1);
    setItemsPerPage(count);
  };

  const handleOrganizationToggle = async (org) => {
    // Optimistically update the UI
    setTableData((prevData) =>
      prevData.map((item) =>
        item.id === org.id
          ? { ...item, organizationActive: !item.organizationActive }
          : item
      )
    );

    const result = await toggleOrganizationStatus(org.id, org.organizationActive);

    // Refresh data after API call to ensure consistency
    if (result?.statusCode === 200) {
      _getTableData(true);
    } else {
      // Revert optimistic update on error
      setTableData((prevData) =>
        prevData.map((item) =>
          item.id === org.id
            ? { ...item, organizationActive: !item.organizationActive }
            : item
        )
      );
    }
  };

  const handleBrandSetupToggle = async (org) => {
    // Use the correct field name from backend
    const currentStatus = org.is_brand_setup_complete || false;

    // Optimistically update the UI
    setTableData((prevData) =>
      prevData.map((item) =>
        item.id === org.id
          ? { ...item, is_brand_setup_complete: !currentStatus }
          : item
      )
    );

    const result = await toggleOrganizationBrandSetupFlow(org.id, currentStatus);

    // Refresh data after API call to ensure consistency
    if (result?.statusCode === 200) {
      _getTableData(true);
    } else {
      // Revert optimistic update on error
      setTableData((prevData) =>
        prevData.map((item) =>
          item.id === org.id
            ? { ...item, is_brand_setup_complete: currentStatus }
            : item
        )
      );
    }
  };

  const handleAddMatchCredits = async (org, credits, mode) => {
    console.log('HANDLE ADD MATCH CREDITS', org, credits, mode);
    await addMatchCredits(org.id, credits, mode);
    // Refresh the table
    _getTableData(true);
  };

  const handleUpdateSeats = async (org, seats) => {
    await updateOrganizationSeats(org.id, seats);
    // Refresh the table
    _getTableData(true);
  };

  const handleRemoveReferral = async (org) => {
    const confirm = window.confirm(
      `Are you sure you want to remove the referral "${org.referral_name || org.referral}" from ${org.name}?`
    );
    if (!confirm) return;

    const result = await removeOrganizationReferral(org.id);
    if (result?.statusCode === 200) {
      _getTableData(true);
    }
  };

  const handleSubscribePittiPlan = async (org, planId, existingPlanAction) => {
    await subscribeOrganizationPittiPlan(org.id, planId, existingPlanAction);
    // Refresh the table
    _getTableData(true);
  };

  const handleSubscribeHyperscoutPlan = async (org, planId, customPlanData, existingPlanAction) => {
    // If customPlanData is provided, it's a custom plan subscription
    if (customPlanData) {
      await subscribeCustomHyperscoutPlan(org.id, customPlanData, existingPlanAction);
    } else {
      await subscribeHyperscoutPlan(org.id, planId, existingPlanAction);
    }
    // Refresh the table
    _getTableData(true);
  };

  const openCreditModal = (org) => {
    // Transform org data to match the modal's expected format
    setSelectedOrganization({
      ...org,
      organizationId: org.id,
      organizationName: org.name,
      organizationType: org.type,
      totalMatchCredits: org.matchCredits,
    });
    setCreditModalOpen(true);
  };

  const openPlanModal = (org) => {
    setSelectedOrganization(org);
    setPlanModalOpen(true);
  };

  const openHyperscoutPlanModal = (org) => {
    setSelectedOrganization(org);
    setHyperscoutPlanModalOpen(true);
  };

  const openPlanDetailsModal = (org) => {
    setSelectedOrganization(org);
    setPlanDetailsModalOpen(true);
  };

  const openOrganizationDetailsModal = (org) => {
    setSelectedOrganization(org);
    setOrganizationDetailsModalOpen(true);
  };

  const openTrialModal = (org) => {
    setSelectedOrganization(org);
    setTrialModalOpen(true);
  };

  const handleActivateTrial = async (org, trialDays, existingPlanAction) => {
    const result = await activateTrial(org.id, trialDays, existingPlanAction);
    if (result?.statusCode === 200) {
      _getTableData(true);
    }
  };

  const handleCancelSubscription = async () => {
    try {
      setCancelSubLoading(true);
      const result = await cancelSubscription(cancelSubOrg);
      if (result?.statusCode === 200) {
        _getTableData(true);
      }
    } catch (e) {
      console.error('Cancel subscription error:', e);
    } finally {
      setCancelSubLoading(false);
      setCancelSubConfirmModal(false);
      setCancelSubOrg(null);
      setCancelSubOrgName(null);
    }
  };

  const handleResetAccount = async () => {
    try {
      setResetAccountLoading(true);
      const orgIds = singleResetAccountOrg
        ? [singleResetAccountOrg]
        : selectedRowsData?.selectedRows?.map((org) => org.id);

      const result = await resetOrganizationAccount(orgIds);
      if (result?.statusCode === 200) {
        _getTableData(true);
        setSelectedRowsData(null);
      }
    } catch (e) {
      console.error('Reset account error:', e);
    } finally {
      setResetAccountLoading(false);
      setResetAccountModal(false);
      setSingleResetAccountOrg(null);
    }
  };

  const handleDelete = async () => {
    try {
      setDeleteLoading(true);
      const orgIds = singleDeleteOrg
        ? [singleDeleteOrg]
        : selectedRowsData?.selectedRows?.map((org) => org.id);

      const result = await deleteOrganizations(orgIds);

      if (result?.statusCode === 200) {
        // Refresh table after deletion
        _getTableData();
        setSelectedRowsData(null);
      }
    } catch (e) {
      console.error('Delete error:', e);
    } finally {
      setDeleteLoading(false);
      setConfirmationModal(false);
      setSingleDeleteOrg(null);
    }
  };

  const handleHubSpotTrigger = async (row) => {
    const user = row?.user?.[0] || {}

    axios.post('https://hook.eu1.make.com/54a2lah2tlodxx5fu24vs13i4geustlx', {
      website: row?.website,
      name: row?.name,
      role: user?.role,
      email: user?.email,
      phone: String(user?.phone),
      username: user?.name || row?.name,
      type: 'brand',
      referral: 'Independent',
      source: 'hyperscout_registration'
    })
      .then(async (res) => {
        if (typeof res?.data === 'string' && res?.data?.includes('hs_contact_id')) {
          await markHubspotTriggered(row.id)

          _getTableData();
        }
      }).catch(err => {
        toast.error(
          "Failed to get a valid reponse from hubspot",
          { autoClose: 3000 }
        );
      })
  }

  const getOrganizationDetailPath = (type, id) => {
    if (type === 'sales_agent') return `/sales-agent/${id}`;
    if (type === 'brand' || type === 'retailer') return `/organization/${id}`;
    return null;
  };

  const columns = [
    {
      name: 'Id',
      selector: (row) => row.id,
      sortable: true,
      center: false,
    },
    {
      name: '',
      cell: (row) => {
        const detailPath = getOrganizationDetailPath(row?.type, row.id);
        if (!detailPath) return null;

        return (
          <button
            type="button"
            className="btn btn-link p-0"
            onClick={() =>
              navigate(detailPath, {
                state: { organization: row },
              })
            }
            title="View details"
          >
            <Eye size={16} />
          </button>
        );
      },
      center: true,
      width: '50px',
    },
    {
      name: 'Organization Name',
      cell: (row) => {
        const tooltipId = `orgname-tooltip-${row.id}`;
        return (
          <>
            <div
              id={tooltipId}
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {row.name || '--'}
            </div>
            <UncontrolledTooltip placement="top" target={tooltipId}>
              {row.name || 'N/A'}
            </UncontrolledTooltip>
          </>
        );
      },
      sortable: true,
      center: false,
      width: '180px',
    },
    {
      name: 'Website',
      cell: (row) => {
        if (!row.website) return '--';
        const tooltipId = `website-tooltip-${row.id}`;
        return (
          <>
            <a
              id={tooltipId}
              href={/^https?:\/\//i.test(row.website) ? row.website : `https://${row.website}`}
              target="_blank"
              rel="noreferrer"
              style={{ color: '#007bff', textDecoration: 'underline' }}
            >
              Open Website
            </a>
            <UncontrolledTooltip placement="top" target={tooltipId}>
              {row.website}
            </UncontrolledTooltip>
          </>
        );
      },
      sortable: true,
      center: false,
      width: '180px',
    },
    {
      name: 'Type',
      selector: (row) => getCamelCaseWord(row.type || '--'),
      sortable: true,
      center: false,
      width: '120px',
    },
    {
      name: 'Plan Name',
      selector: (row) => row.plan_details?.name || '--',
      sortable: false,
      center: false,
      width: '120px',
    },
    {
      name: 'Credit Usage',
      selector: (row) => Object.keys(row.plan_details || {}).length > 0 ? `${row.plan_details?.credits}/${row.plan_details?.max_credits}` : '--',
      sortable: false,
      center: false,
      width: '120px',
    },
    {
      name: 'View Plan Details',
      cell: (row) => (
        row.is_premium && row.plan_details ? (
          <button
            onClick={() => openPlanDetailsModal(row)}
            style={{
              background: 'none',
              border: 'none',
              color: '#007bff',
              textDecoration: 'underline',
              cursor: 'pointer',
              fontSize: '14px',
              padding: 0,
            }}
          >
            View Details
          </button>
        ) : (
          <span>--</span>
        )
      ),
      sortable: false,
      center: true,
      width: '150px',
    },
    {
      name: 'Extra Credits',
      selector: (row) => row.extra_credit_details?.max_credits > 0 ? `${row.extra_credit_details?.credits || 0}/${row.extra_credit_details?.max_credits}` : '--',
      sortable: true,
      center: true,
      width: '150px',
    },
    {
      name: 'Subscription Status',
      cell: (row) => (
        row.is_premium ? (
          <span
            style={{
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '12px',
              fontWeight: 'bold',
              backgroundColor: row.is_subscription_paused ? '#999999' : '#e8f5e9',
              color: row.is_subscription_paused ? '#ffffff' : '#2e7d32',
            }}
          >
            {row.is_subscription_paused ? 'Paused' : 'Active'}
          </span>
        ) : (
          <span
            style={{
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '12px',
              fontWeight: 'bold',
              backgroundColor: '#fff3cd',
              color: '#856404',
            }}
          >
            In Active
          </span>
        )
      ),
      sortable: true,
      center: true,
      width: '150px',
    },
    {
      name: 'Joined Date',
      selector: (row) => row.created_at ? new Date(row.created_at).toLocaleDateString() : '--',
      sortable: true,
      center: false,
      width: '120px',
    },
    {
      name: 'Trial Status',
      cell: (row) => {
        const status = row.is_on_trial
          ? { label: 'On Trial', bg: '#e3f2fd', color: '#1565c0' }
          : row.is_trial_ended
            ? { label: 'Trial Ended', bg: '#eeeeee', color: '#616161' }
            : { label: 'No Trial', bg: '#fff3cd', color: '#856404' };
        return (
          <span
            style={{
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '12px',
              fontWeight: 'bold',
              backgroundColor: status.bg,
              color: status.color,
            }}
          >
            {status.label}
          </span>
        );
      },
      sortable: true,
      center: true,
      width: '130px',
    },
    {
      name: 'Trial Started At',
      // No trial_started_at column; every trial-start path sets trial_ends_at = now + trial_period
      selector: (row) => {
        if (!row?.trial_ends_at) return '--';
        const start = new Date(row.trial_ends_at);
        start.setDate(start.getDate() - (row.trial_period || 14));
        return start.toLocaleDateString();
      },
      sortable: true,
      center: false,
      width: '160px',
    },
    {
      name: 'Trial Expires At',
      selector: (row) => row?.trial_ends_at ? new Date(row.trial_ends_at).toLocaleDateString() : '--',
      sortable: true,
      center: false,
      width: '200px',
    },
    {
      name: 'Plan Last Renewal Date',
      selector: (row) => row?.plan_renewed_at ? new Date(row.plan_renewed_at).toLocaleDateString() : '--',
      sortable: true,
      center: false,
      width: '200px',
    },
    {
      name: 'Plan Next Renewal Date',
      selector: (row) => row.plan_next_renewal_at ? new Date(row.plan_next_renewal_at).toLocaleDateString() : '--',
      sortable: true,
      center: false,
      width: '200px',
    },
    {
      name: 'Referral',
      cell: (row) => {
        const hasReferral = row?.referral_name || (row?.referral && row.referral !== 'Independent');
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', maxWidth: '150px' }}>
            <p style={{ textWrap: 'nowrap', wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', margin: 0 }}>
              {row?.referral_name || '--'}
            </p>
            {hasReferral && (
              <button
                type="button"
                title="Remove referral"
                onClick={() => handleRemoveReferral(row)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#fef2f2',
                  border: '1px solid #fecaca',
                  borderRadius: '4px',
                  color: '#dc3545',
                  cursor: 'pointer',
                  padding: '2px',
                  flexShrink: 0,
                  lineHeight: 0,
                }}
              >
                <X size={12} />
              </button>
            )}
          </div>
        );
      },
      sortable: true,
      center: true,
      width: '180px',
    },
    {
      name: 'Source',
      cell: (row) => getCamelCaseWord(row.source || '--'),
      sortable: true,
      center: true,
      width: '150px',
    },
    {
      name: 'Members',
      selector: (row) => row.totalMembers || 0,
      sortable: true,
      center: true,
      width: '100px',
    },
    {
      name: 'Details',
      cell: (row) => (
        <button
          onClick={() => openOrganizationDetailsModal(row)}
          style={{
            background: 'none',
            border: 'none',
            color: '#007bff',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: '14px',
            padding: 0,
          }}
        >
          View Details
        </button>
      ),
      sortable: false,
      center: true,
      width: '130px',
    },
    {
      name: 'Last Activity',
      selector: (row) => {
        const tooltipId = `last-activity-${row.id}`;
        const engagement = row?.engagements?.[0]
        const value = engagement ?
          `${engagement?.engagement_type} ${(engagement?.target_brand || engagement?.target_retailer)?.name}` : '--';
        return (
          <>
            <div
              id={tooltipId}
              style={{
                fontSize: '13px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {value}
            </div>
            <UncontrolledTooltip placement="top" target={tooltipId}>
              {value}
            </UncontrolledTooltip>
          </>
        )
      },
      sortable: true,
      center: false,
      width: '200px',
    },
    {
      name: 'Last Activity At',
      selector: (row) => {
        const tooltipId = `last-activity-at-${row.id}`;
        const engagement = row?.engagements?.[0]
        const value = engagement ? new Date(engagement?.created_at).toLocaleDateString() : '--';
        return (
          <>
            <div
              id={tooltipId}
              style={{
                fontSize: '13px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {value}
            </div>
            <UncontrolledTooltip placement="top" target={tooltipId}>
              {value}
            </UncontrolledTooltip>
          </>
        )
      },
      sortable: true,
      center: false,
      width: '200px',
    },
    {
      name: 'Last Login',
      selector: (row) => {
        const tooltipId = `last-login-${row.id}`;
        const login = row?.lastLogin;
        const value = login ? new Date(login.last_login).toLocaleString() : '--';
        return (
          <>
            <div id={tooltipId} style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>
              {value}
            </div>
            {login && (
              <UncontrolledTooltip placement="top" target={tooltipId}>
                {login.name || login.email}
              </UncontrolledTooltip>
            )}
          </>
        );
      },
      sortable: true,
      center: false,
      width: '180px',
    },
    {
      name: 'Discount Applied',
      selector: (row) => row.discount_applied || '--',
      sortable: true,
      center: true,
      width: '150px',
    },
    {
      name: 'Toggle Organization',
      cell: (row) => (
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            checked={row.organizationActive}
            onChange={() => handleOrganizationToggle(row)}
            style={{ cursor: 'pointer' }}
          />
        </div>
      ),
      center: true,
      width: '160px',
    },
    {
      name: 'Brand Setup Flow',
      cell: (row) => row?.type === 'brand' ? (
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            checked={row.is_brand_setup_complete || false}
            onChange={() => handleBrandSetupToggle(row)}
            style={{ cursor: 'pointer' }}
            title={row.is_brand_setup_complete ? 'Brand Setup Completed' : 'Brand Setup Pending'}
          />
          <label
            className="form-check-label ms-1 small"
            style={{
              color: row.is_brand_setup_complete ? '#2e7d32' : '#757575',
              fontSize: '11px'
            }}
          >
            {row.is_brand_setup_complete ? 'Active' : 'Inactive'}
          </label>
        </div>
      ) : <span>--</span>,
      center: true,
      width: '160px',
    },
    {
      name: 'Hubspot Status',
      cell: (row) => {
        return (
          <span className={`badge ${row?.hubspot_triggered ? 'badge-success' : 'badge-danger'}`}>
            {row?.hubspot_triggered ? <Check size={14} /> : <X size={14} />}
          </span>
        )
      },
      center: true,
      width: '180px',
    },
    {
      name: 'Send to HubSpot',
      cell: (row) => {
        return row?.hubspot_triggered ? (
          <span className="badge badge-success">Triggered</span>
        ) : (
          <Button
            color="warning"
            size="sm"
            outline
            onClick={() => handleHubSpotTrigger(row)}
          >
            Send to HubSpot
          </Button>
        )
      },
      center: true,
      width: '180px',
    },
    {
      name: 'Send Invite',
      cell: (row) => (
        <Button
          color="primary"
          size="sm"
          outline
          disabled={inviteLoadingOrgId === row.id}
          onClick={() => handleSendInvite(row)}
        >
          {inviteLoadingOrgId === row.id ? 'Sending...' : 'Send Invite'}
        </Button>
      ),
      center: true,
      width: '150px',
    },
    {
      name: 'Reset Account',
      cell: (row) => (
        <Button
          color="warning"
          size="sm"
          outline
          onClick={() => {
            setSingleResetAccountOrg(row.id);
            setResetAccountModal(true);
          }}
        >
          Reset
        </Button>
      ),
      center: true,
      width: '130px',
    },
    {
      name: 'Options',
      cell: (row) => (
        <>
          <Eye size={14} className="me-1" onClick={() => window.open(`/organization-engagements/${row.id}`, '_blank')} />
          <UncontrolledDropdown >
            <DropdownToggle tag="button" className="btn btn-link p-0">
              <MoreVertical size={20} color="#999" />
            </DropdownToggle>
            <DropdownMenu end>
              {row?.is_premium && (
                <DropdownItem onClick={() => openCreditModal(row)}>
                  Add More Credits
                </DropdownItem>
              )}
              {/* {row?.is_premium && (
                <DropdownItem onClick={() => openSeatsModal(row)}>
                  Edit Seats
                </DropdownItem>
              )} */}
              <DropdownItem onClick={() => openPlanModal(row)}>
                Subscribe Pitti Plan
              </DropdownItem>
              <DropdownItem onClick={() => openHyperscoutPlanModal(row)}>
                Subscribe Hyperscout Plan
              </DropdownItem>
              <DropdownItem onClick={() => openTrialModal(row)}>
                Activate Trial
              </DropdownItem>
              {/* {row?.is_premium && (
                <DropdownItem
                  onClick={() => {
                    setCancelSubOrg(row.id);
                    setCancelSubOrgName(row.name);
                    setCancelSubConfirmModal(true);
                  }}
                  className="text-danger"
                >
                  Cancel Subscription
                </DropdownItem>
              )} */}
              <DropdownItem
                onClick={() => {
                  setSingleDeleteOrg(row.id);
                  setConfirmationModal(true);
                }}
                className="text-danger"
              >
                <Trash size={14} className="me-1" /> Delete
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </>
      ),
      center: true,
      width: '100px',
    },
  ];

  return (
    <Container fluid style={{ padding: "20px 0px" }}>
      <Card>
        <CardBody>
          <Row className="align-items-center justify-content-between mb-3">
            <Col xs="auto" className="d-flex flex-row gap-3 align-items-center">
              {selectedRowsData?.selectedCount > 0 && (
                <>
                  <Button outline color="warning" onClick={() => setResetAccountModal(true)}>
                    Reset Account ({selectedRowsData.selectedCount})
                  </Button>
                  <Button outline color="primary" onClick={() => setConfirmationModal(true)}>
                    <Trash /> Delete ({selectedRowsData.selectedCount})
                  </Button>
                </>
              )}
            </Col>
            <Col xs="auto" className="d-flex flex-row gap-3 align-items-center">
              <MultiSelectFilterDropDown
                data={filterData || {}}
                filters={filters || {}}
                isLoading={filterLoading}
                onFilterApply={setFilters}
              />
              <Label className="mb-0">Search:</Label>
              <Input
                type="text"
                placeholder="Search by organization name or website"
                value={searchTerm}
                onChange={handleSearchChange}
                style={{ minWidth: '350px' }}
              />
              <Button
                id="export-organizations-btn"
                color="success"
                outline
                onClick={handleExport}
                disabled={exportLoading}
                style={{ whiteSpace: 'nowrap' }}
              >
                {exportLoading ? 'Exporting...' : '⬇ Export Excel'}
              </Button>
            </Col>
          </Row>
          <div className="table-responsive mt-3">
            <DataTable
              striped
              pagination
              data={tableData}
              columns={columns}
              className="display"
              paginationServer
              progressPending={isLoading}
              paginationTotalRows={totalOrganizations}
              paginationPerPage={itemsPerPage}
              paginationDefaultPage={page}
              selectableRows={true}
              customStyles={{ tableWrapper: { style: { minHeight: 500 } } }}
              onSelectedRowsChange={setSelectedRowsData}
              onChangePage={(newPage) => setPage(newPage)}
              onChangeRowsPerPage={handleItemPerPageSelect}
            />
          </div>
        </CardBody>
      </Card>
      <AddMatchCreditsModal
        open={creditModalOpen}
        onClose={() => {
          setCreditModalOpen(false);
          setSelectedOrganization(null);
        }}
        organization={selectedOrganization}
        onSubmit={handleAddMatchCredits}
      />
      <EditSeatsModal
        open={seatsModalOpen}
        onClose={() => {
          setSeatsModalOpen(false);
          setSelectedOrganization(null);
        }}
        organization={selectedOrganization}
        onSubmit={handleUpdateSeats}
      />
      <SubscribePittiPlanModal
        open={planModalOpen}
        onClose={() => {
          setPlanModalOpen(false);
          setSelectedOrganization(null);
        }}
        organization={selectedOrganization}
        onSubmit={handleSubscribePittiPlan}
        onToggleSubscription={async (org, isPaused) => {
          await toggleSubscription(org.id, isPaused);
          _getTableData(true);
        }}
      />
      <SubscribeHyperscoutPlanModal
        open={hyperscoutPlanModalOpen}
        onClose={() => {
          setHyperscoutPlanModalOpen(false);
          setSelectedOrganization(null);
        }}
        organization={selectedOrganization}
        onSubmit={handleSubscribeHyperscoutPlan}
        onToggleSubscription={async (org, isPaused) => {
          await toggleSubscription(org.id, isPaused);
          _getTableData(true);
        }}
        onCancelSubscription={async (orgId) => {
          const result = await cancelSubscription(orgId);
          if (result?.statusCode === 200) {
            _getTableData(true);
          }
          return result;
        }}
      />
      <PlanDetailsModal
        open={planDetailsModalOpen}
        onClose={() => {
          setPlanDetailsModalOpen(false);
          setSelectedOrganization(null);
        }}
        organization={selectedOrganization}
      />
      <OrganizationDetailsModal
        open={organizationDetailsModalOpen}
        onClose={() => {
          setOrganizationDetailsModalOpen(false);
          setSelectedOrganization(null);
        }}
        organization={selectedOrganization}
        fetchMetrics={getOrganizationMetrics}
      />
      <ConfirmationModal
        open={confirmationModal}
        onClose={() => {
          setConfirmationModal(false);
          setSingleDeleteOrg(null);
        }}
        onSubmit={handleDelete}
        isLoading={deleteLoading}
        title="Delete Organization"
        message={
          singleDeleteOrg
            ? "Are you sure you want to permanently delete this organization and ALL its users from the database? This action cannot be undone and will remove all associated data."
            : `Are you sure you want to permanently delete ${selectedRowsData?.selectedCount || 0} organization(s) and ALL their users from the database? This action cannot be undone and will remove all associated data.`
        }
      />
      <ActivateTrialModal
        open={trialModalOpen}
        onClose={() => {
          setTrialModalOpen(false);
          setSelectedOrganization(null);
        }}
        organization={selectedOrganization}
        onSubmit={handleActivateTrial}
      />
      <CancelSubscriptionModal
        open={cancelSubConfirmModal}
        onClose={() => {
          setCancelSubConfirmModal(false);
          setCancelSubOrg(null);
          setCancelSubOrgName(null);
        }}
        onSubmit={handleCancelSubscription}
        isLoading={cancelSubLoading}
        organizationName={cancelSubOrgName}
      />
      <ConfirmationModal
        open={resetAccountModal}
        onClose={() => {
          setResetAccountModal(false);
          setSingleResetAccountOrg(null);
        }}
        onSubmit={handleResetAccount}
        isLoading={resetAccountLoading}
        title="Reset Organization Account"
        confirmButtonText="Confirm"
        message={
          singleResetAccountOrg
            ? "This will reset this organization's any ongoing subscription and give the organization a free trial, and it will delete all engagements and credit usage of this organization. Are you sure you want to reset?"
            : `This will reset ${selectedRowsData?.selectedCount || 0} organization(s)' any ongoing subscription and give them a free trial, and it will delete all engagements and credit usage of these organizations. Are you sure you want to reset?`
        }
      />
    </Container>
  );
}

const mapStateToProps = (state) => ({
  allOrganizations: state.organizationManagement.allOrganizations,
  totalOrganizations: state.organizationManagement.totalOrganizations,
  isLoading: state.organizationManagement.isLoading,
  filterData: state.organizationManagement.filterData,
  filterLoading: state.organizationManagement.filterLoading,
  filters: state.organizationManagement.filters,
});

const mapDispatchToProps = {
  getAllOrganizations: getAllOrganizationsAction,
  toggleOrganizationStatus: toggleOrganizationStatusAction,
  addContactCredit: addContactCreditAction,
  updateOrganizationSeats: updateOrganizationSeatsAction,
  subscribeOrganizationPittiPlan: subscribeOrganizationPittiPlanAction,
  subscribeHyperscoutPlan: subscribeHyperscoutPlanAction,
  subscribeCustomHyperscoutPlan: subscribeCustomHyperscoutPlanAction,
  toggleSubscription: toggleSubscriptionAction,
  deleteOrganizations: deleteOrganizationsAction,
  activateTrial: activateTrialAction,
  cancelSubscription: cancelSubscriptionAction,
  markHubspotTriggered: markHubspotTriggeredAction,
  toggleOrganizationBrandSetupFlow: toggleOrganizationBrandSetupFlowAction,
  resetOrganizationAccount: resetOrganizationAccountAction,
  getOrganizationFilters: getOrganizationFiltersAction,
  setFilters: setFiltersAction,
  getOrganizationMetrics: getOrganizationMetricsAction,
  exportOrganizations: exportOrganizationsAction,
  addMatchCredits: addMatchCreditsAction,
  removeOrganizationReferral: removeOrganizationReferralAction,
  sendInviteEmail: sendInviteEmailAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationManagementTab);

